import { EditNote, PlaylistAdd } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { FramerTooltip } from "@ryde/controls";
import { useReportsContext } from "@ryde/redux";
import {
  reportModalEditAtom,
  ReportModalEditModeEnum,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";
import { deepPurpleMui } from "@ryde/theme";

import { SaveReportDialog } from "./save-report-dialog";

export const SaveReportDialogButton: FC = () => {
  const { t } = useTranslation();
  const { isReportEditAvailableForReport } = useReportsContext();
  const buttonsColor = deepPurpleMui.A700;
  const [modalOpen, setModalOpen] = useRecoilState(reportModalEditAtom);

  const onEditClick = (): void => {
    setModalOpen(ReportModalEditModeEnum.Edit);
  };

  const onCreateClick = (): void => {
    setModalOpen(ReportModalEditModeEnum.Create);
  };

  return (
    <>
      {isReportEditAvailableForReport && (
        <IconButton onClick={onEditClick}>
          <FramerTooltip
            content={t("report.EDIT_REPORT")}
            mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
          >
            <EditNote
              sx={{ color: buttonsColor }}
              className="report_action_button"
            />
          </FramerTooltip>
        </IconButton>
      )}
      <IconButton onClick={onCreateClick}>
        <FramerTooltip
          content={t("report.ADD_REPORT")}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <PlaylistAdd className="report_action_button" />
        </FramerTooltip>
      </IconButton>
      {Boolean(modalOpen) && <SaveReportDialog />}
    </>
  );
};
